export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "活动ID", prop: "active_id", width: 100, },
    // { label: "评论内容", prop: "message" },
    // { label: "档案来源", prop: "source", slots: "source" },
    { label: "投票者小程序openid", prop: "vote_openid", },
    { label: "投票者手机号", prop: "vote_phone", slots: "vote_phone"},
    // { label: "档案", prop: "message", slots: "message", width: 160, },
    {
      label: "投票日期",
      prop: "createTime",
      width: 180,
    },
    // { label: "会话ID", prop: "answerNumber", slots: "answerNumber", width: 220, },
    {
      label: "操作",
      prop: "operation",
      width: 80,
      slots: "operation",
      fixed: "right",
    },
  ];
}
